import { EventEmitter, Injectable, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Scheduler } from "@bryntum/scheduler-thin";

@Injectable({
  providedIn: "root"
})
export class DiaryService {
  @Output() schedulerEvents = new EventEmitter<object>();
  private _schedulerBehaviour: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor() {}

  public get scheduler(): BehaviorSubject<any> {
    return this._schedulerBehaviour;
  }

  public updateScheduler(scheduler: Scheduler) {
    this._schedulerBehaviour.next(scheduler);
  }
}
